import React from "react";
import { makeStyles } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import TopBar from "./TopBar";

const useStyles = makeStyles((theme) => ({
  root: {
    // backgroundColor: "transperent",
    backgroundColor: "#0d0d0d",
    position: "relative",
    zIndex: "9",
    // height: "100dvh",
    overflow: "hidden",
  },
  MainLayout: {
    // minHeight: "calc(100vh - 469px)",
  },
}));

const MainLayout = ({ children }) => {
  const classes = useStyles();
  const history = useHistory();
  return (
    <div className={classes.root}>
      <TopBar />
      <div
        style={
          history.location.pathname !== "/"
            ? { display: "block" }
            : { display: "none" }
        }
      ></div>

      <div className={classes.MainLayout}>{children}</div>
    </div>
  );
};

export default MainLayout;
